import React from "react";
import styles from "./AddChannel.module.scss";
import ExitIcon from "../../assets/icons/ExitIcon";
import CustomButton from "../CustomButton/CustomButton";
import TelegramIcon from "../../assets/icons/TelegramIcon";
import ChannelsIcon from "../../assets/icons/accountSidebar/ChanalesIcon";
import ProgressBar from "../ProgressBar/ProgressBar";
import { useTranslation } from "react-i18next";

const AddChannel = ({ setAddChannel, setOpenModal }) => {
  const { t } = useTranslation();

  const handleOpenModal = (type) => {
    setOpenModal(type);
    setAddChannel(false);
  };

  return (
    <div className={styles.addChannelContainer}>
      <div className={styles.addChannelHeader}>
        <h2 className={styles.addChannelTitle}>
          {t("channels.connectChannel")}
        </h2>
        <ExitIcon onClick={() => setAddChannel(false)} />
      </div>
      <ProgressBar step={1} maxStep={4} />
      <div className={styles.addChannelFooter}>
        <CustomButton height="83px" onClick={() => handleOpenModal("telegram")}>
          <div className={styles.buttonContent}>
            <TelegramIcon size={30} />
            <h3 className={styles.buttonTitle}>{t("channels.telegram")}</h3>
          </div>
        </CustomButton>
        <CustomButton height="83px" onClick={() => handleOpenModal("another")}>
          <div className={styles.buttonContent}>
            <ChannelsIcon size={30} color={"#2AABEE"} />
            <h3 className={styles.buttonTitle}>
              {t("channels.anotherChannel")}
            </h3>
          </div>
        </CustomButton>
      </div>
    </div>
  );
};

export default AddChannel;
